import { Formik } from 'formik';
import { EditPatientNoteFormContextProvider } from '~/lib/contexts/EditPatientNoteFormContext';
import { EditNoteDrawer } from '~/components/common/EditNoteDrawer';
import { useEditNoteDrawerContext } from '~/lib/contexts/EditNoteDrawerContext';
import { EditNoteFormData } from '~/lib/types/notes/EditNoteFormData';
import { DateTime } from 'luxon';

const initialFormValues: EditNoteFormData = {
  aiSummaryId: null,
  activity: [],
  activityDate: DateTime.now().toJSDate(), // null ?
  addendumContent: '',
  appointment: null,
  attendees: [],
  declinedUsers: [],
  isConfidential: false,
  medium: null,
  noteTemplateRevision: null,
  noteTemplateRevisionData: null,
  sessionSummary: null,
  title: '',
  type: null,
};

export const EditNoteDrawerForm = () => {
  const { drawerStatus } = useEditNoteDrawerContext();
  if (drawerStatus === 'closed') {
    return <></>;
  }
  return (
    <Formik
      initialValues={initialFormValues}
      onSubmit={() => {}} // We handle submission manually
    >
      <EditPatientNoteFormContextProvider>
        <EditNoteDrawer />
      </EditPatientNoteFormContextProvider>
    </Formik>
  );
};
